import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { toast } from "react-toastify";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import styled from "styled-components";
import { useApi } from "../../../hooks/useApi";
import DropDown, { OptionType } from "../../Filters/DropDown";
import DefaultModalLayout, {
  defaultModalType,
} from "../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../Users/UserDetail/CommentModal/CommentModal";
import TargetContainer, {
  CommentTargetContainer,
  ModalLabel,
} from "../Users/UserDetail/CommentModal/TargetContainer";
import PreviewSection, {
  alimTalkInputValue,
  alimTalkPreviewBtnClick,
  selectedAccountIdAtom,
} from "./AlimTalkModal/PreviewSection";
import alertevent_set from "../../../data_json/alertevent_set.json";
import {
  GetAllNoHideSubsnameListv3,
  GetSubscriptionSetData_V3,
  getUserEventData,
} from "../../../ApiTS/ServiceDatasTS_V3";
import { ModalRow } from "../Users/UserDetail/BlackListModal/BlackListModal";
import { DeleteModalLabel } from "../Users/UserDetail/CommentModal/CommentDeleteModal";
import StatusCodeBox from "./AlimTalkModal/StatusCodeBox";
import AlertModal from "../../Modal/AlertModal";
import ConfirmBtn from "../../Button/ConfirmBtn";
import { IAlertEvt } from "../../../ApiTS/CommonType";

dayjs.extend(customParseFormat); // 플러그인 등록

interface AlimTalkModalProps extends DefaultModalCommonProps {
  talkData?: string;
  viewData?: {
    user: string;
    template: string;
    subsData?: string;
    sender?: string;
    sendTime?: string;
    partyId?: string;
    grade?: number;
  };
  status?: {
    kakao: string;
    sms: string;
    api: string;
  };
  userAccount?: string;
}

export default function AlimTalkModal({
  closeEvent,
  type,
  talkData,
  viewData,
  confirmEvent,
  status,
  userAccount,
}: AlimTalkModalProps) {
  console.log(status);
  console.log(viewData);

  const [modalType, setModalType] = useRecoilState(defaultModalType);

  const [targetUid, setTargetUid] = useState(viewData ? viewData?.user : "");
  const [subsValue, setSubsValue] = useState<OptionType>({
    value: viewData?.subsData ? `${viewData?.subsData?.split("_")[0]}` : "",
    label: viewData?.subsData ? `${viewData?.subsData?.split("_")[1]}` : "선택",
  });
  const [templateValue, setTemplateValue] = useState<OptionType>({
    value: viewData?.template ? viewData?.template?.split("_")[0] : "",
    label: viewData?.template ? viewData?.template?.split("_")[1] : "선택",
  });
  const setPreviewBtnClick = useSetRecoilState(alimTalkPreviewBtnClick); // 미리보기 버튼
  const [previewValue, setPreviewValue] = useState<string | undefined>(
    talkData ?? ""
  );
  const [filteredAlertData, setFilteredAlertData] = useState<IAlertEvt[]>([]);
  const [templateOption, setTemplateOption] = useState<OptionType[]>([]);

  const [selectedAccountId, setSelectedAccountId] = useRecoilState(
    selectedAccountIdAtom
  );

  const inputValue = useRecoilValue(alimTalkInputValue);
  const [sendAskModal, setSendAskModal] = useState(false);
  const [sendAlimTalk, setSendAlimTalk] = useState(false);

  const extractedDuedateText = inputValue
    ?.split("사용 기한: ")[1]
    ?.split(" 자정")[0]
    ?.match(/\d+/g) as string[];

  const extractedDuedate =
    extractedDuedateText?.length > 0 &&
    selectedAccountId !== "" &&
    inputValue?.split("사용 기한: ")?.[1]
      ? `${
          extractedDuedateText[0]?.length > 2
            ? extractedDuedateText[0]
            : `20${extractedDuedateText[0]}`
        }-${
          Number(extractedDuedateText[1]) > 9
            ? extractedDuedateText[1]
            : `0${extractedDuedateText[1]}`
        }-${
          Number(extractedDuedateText[2]) > 9
            ? extractedDuedateText[2]
            : `0${extractedDuedateText[2]}`
        }`
      : "";

  console.log(extractedDuedate);
  console.log(templateValue?.value);

  const userEventId = templateValue.value ? +templateValue.value : 0;

  // 알림톡 보내기
  const { response: sendResponse, error } = useApi({
    method: "post",
    url: sendAlimTalk ? `kakao/send` : undefined,
    data: {
      uid: Number(targetUid?.split("_")[0]),
      userevt: userEventId,
      alert_msg: inputValue,
      tmpAccountId: Number(selectedAccountId !== "" ? selectedAccountId : 0),
      ...(viewData?.partyId ? { partyid: Number(viewData?.partyId) } : {}),
      duedate: extractedDuedate ?? "",
      servsubsid: Number(subsValue?.value ?? 0),
      reciverType:
        alertevent_set?.find((a) => a.USEREVT_ID === userEventId)?.ALERT_RCVR ??
        0,
    },
  });

  console.log(extractedDuedateText);

  const subsNameList = GetAllNoHideSubsnameListv3();

  const subsOptionList = [];

  for (let i = 0; i < subsNameList.length; i++) {
    const e = subsNameList[i];

    subsOptionList.push({
      value: e?.split("_")[0],
      label: e?.split("_")[1],
      isDisabled: undefined,
    });
  }

  // 알림톡 보내기
  useEffect(() => {
    if (sendResponse?.status === 201) {
      setSendAskModal(false);

      if (confirmEvent) {
        confirmEvent();
      } else {
        closeEvent();
      }

      toast.success(sendResponse?.data?.result ?? "", {});
      setSelectedAccountId("");
    }
  }, [sendResponse]);

  useEffect(() => {
    if (error) {
      setSelectedAccountId("");
      toast.error(
        error.data ?? error.data[0] ?? "알림톡 보내기에 실패했습니다."
      );
      setSendAskModal(false);
      setSendAlimTalk(false);
    }
  }, [error]);

  useEffect(() => {
    if (type) {
      setModalType(type);
    }
  }, [type]);

  useEffect(() => {}, [previewValue, templateValue?.value, viewData]);

  useEffect(() => {
    if (subsValue.value && subsValue.value !== "") {
      const subsId = +subsValue.value;
      const subsData = GetSubscriptionSetData_V3(subsId);

      const alertId = subsData?.ALERT_ID;
      const alertData = alertevent_set?.filter(
        (a) =>
          a.ALERT_ID === alertId && 900 <= a.USEREVT_ID && a.USEREVT_ID < 1000
      );

      const roleFilteredAlertData = alertData?.filter(
        (a) =>
          a.ALERT_RCVR === "self" ||
          (viewData
            ? viewData?.grade === 1
              ? a.ALERT_RCVR === "mbr"
              : a.ALERT_RCVR === "ldr"
            : true)
      );

      console.log(roleFilteredAlertData);

      setFilteredAlertData(roleFilteredAlertData!);

      const list: OptionType[] = [];

      roleFilteredAlertData?.forEach((r) => {
        const userEventData = getUserEventData(r.USEREVT_ID);

        list.push({
          value: userEventData?.USEREVT_ID + "",
          label: userEventData?.USEREVT_DETAIL,
        });
      });

      setTemplateOption(list);
    }
  }, [subsValue.value]);

  return (
    <DefaultModalLayout
      closeEvent={() => {
        setSelectedAccountId("");
        closeEvent();
      }}
      cancelBtn={type === "input" ? undefined : <></>}
      confirmEvent={() => {
        if (type === "input") {
          setSendAskModal(true);
        } else {
          closeEvent();
        }
      }}
      confirmDisabled={
        modalType === "input"
          ? !targetUid?.split("_")[0] ||
            templateValue?.value === "" ||
            previewValue === "" ||
            (previewValue?.includes("#{alert_msg}") ? inputValue === "" : false)
          : false
      }
      confirmBtnText={modalType === "input" ? "확인" : "닫기"}
      modalTitle={type === "input" ? "알림톡 보내기" : "알림톡 조회"}
      leftBottomName={type === "input" ? undefined : viewData?.sender ?? ""}
      leftBottomTitle={type === "input" ? undefined : "작성자"}
      leftBottomTime={type === "input" ? undefined : viewData?.sendTime}
    >
      {/* 대상 */}
      <ModalRow>
        {type === "input" ? (
          <TargetContainer
            targetUid={targetUid}
            setTargetUid={setTargetUid}
            modalType={modalType}
            isFlexStart={true}
            inputBoxWidth={220}
          />
        ) : (
          <ModalRow>
            <ModalLabel>대상</ModalLabel>

            <ModalRowContentContainer>
              <HasInitValueBox>{targetUid}</HasInitValueBox>
            </ModalRowContentContainer>
          </ModalRow>
        )}
      </ModalRow>

      {/* Subs_name */}
      <>
        {type === "input" && (
          <ModalRow>
            <ModalLabel>Subs_name</ModalLabel>

            <ModalRowContentContainer>
              <DropDown
                setDropDownValue={setSubsValue}
                optionList={subsOptionList}
                dropdownValue={subsValue}
                isDisabled={targetUid?.split("_")[1] ? false : true}
              />
            </ModalRowContentContainer>
          </ModalRow>
        )}
      </>

      {/* 템플릿 */}
      <ModalRow>
        <ModalLabel>템플릿</ModalLabel>

        <ModalRowContentContainer>
          {type === "input" ? (
            <DropDown
              setDropDownValue={setTemplateValue}
              optionList={templateOption}
              dropdownValue={templateValue}
              isDisabled={subsValue?.value === ""}
            />
          ) : (
            <HasInitValueBox>{templateValue?.label}</HasInitValueBox>
          )}

          {type === "input" && (
            <ConfirmBtn
              btnText="미리보기"
              btnColor="mint"
              btnClickEvent={() => {
                setPreviewBtnClick(true);
              }}
              isDisabled={
                templateValue?.value === "" ||
                !targetUid?.includes("_") ||
                subsValue?.value === ""
              }
            />
          )}
        </ModalRowContentContainer>
      </ModalRow>

      {/* 미리보기 */}
      <PreviewSection
        templateValue={templateValue}
        subsValue={subsValue}
        targetUid={targetUid}
        type={type}
        previewValue={previewValue}
        setPreviewValue={setPreviewValue}
        roleFilteredAlertData={filteredAlertData}
        userAccount={userAccount}
      />

      {/* 상태 코드 */}
      <>
        {modalType !== "input" && (
          <>
            <DeleteModalLabel>상태 코드</DeleteModalLabel>

            <StatusCodeBox status={status} />
          </>
        )}
      </>

      <>
        {sendAskModal && (
          <AlertModal
            title={"알림톡을 보내시겠습니까?"}
            btnColor="mint"
            cancelEvent={() => setSendAskModal(false)}
            confirmEvent={() => setSendAlimTalk(true)}
          />
        )}
      </>
    </DefaultModalLayout>
  );
}

export const ModalRowContentContainer = styled(CommentTargetContainer)`
  justify-content: flex-start;
`;

export const HasInitValueBox = styled.div`
  width: 220px;
  height: 38px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 8px 16px;
  display: flex;
  align-items: center;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray500};
`;
